import {styledBox} from "../../../../../../themes/architecture/styled-box";

export interface ISearchClearIconBoxProps {
    visible: boolean;
}

export const SearchClearIconBox = styledBox("SearchClearIconBox");